// extracted by mini-css-extract-plugin
export default {"reviewPhotoGallery":"_p-z","imageAndVideoCount":"aq-z","imageAndVideoContainer":"bq-z","viewAllReviews":"cq-z"};